/**
 * Where a profile's back arrow should land. Lists pass this as navigation
 * state so "Back to Members" returns to the Members tab instead of the
 * Community wall.
 */

export interface ProfileBackTarget {
  path: string;
  label: string;
}

const communityLabel = (search: string): string => {
  const tab = new URLSearchParams(search).get("tab");
  if (tab === "members") return "Members";
  if (tab === "circles") return "Circles";
  return "Community";
};

/** The name shown in the profile's "Back to …" control. */
export const backTargetLabel = (pathname: string, search = ""): string => {
  if (pathname === "/community") return communityLabel(search);
  if (pathname.startsWith("/community/circles")) return "Circles";
  if (pathname === "/") return "Home";
  if (pathname.startsWith("/activities")) return "Activities";
  if (pathname.startsWith("/activity/")) return "the activity";
  if (pathname.startsWith("/play-date/")) return "the playdate";
  if (pathname.startsWith("/my-play-dates")) return "My playdates";
  if (pathname.startsWith("/playdates")) return "Playdates";
  if (pathname.startsWith("/interested")) return "Interested";
  if (pathname.startsWith("/favorites")) return "Saved";
  if (pathname.startsWith("/my-bookings")) return "My bookings";
  if (pathname.startsWith("/noticeboard")) return "Noticeboard";
  if (pathname.startsWith("/local-spotlights")) return "Local Spotlights";
  if (pathname.startsWith("/messages")) return "Messages";
  return "Community";
};

/** Build the back target for the page a profile was opened from. */
export const profileBackTarget = (
  pathname: string,
  search = "",
  label?: string
): ProfileBackTarget => ({
  path: `${pathname}${search}`,
  label: label?.trim() || backTargetLabel(pathname, search),
});
